import { types, getParent, getRoot } from 'mobx-state-tree';
import NotificationsGroup from './NotificationsGroup';

const Notifications = types
  .model('notifications', {
    groups: types.optional(types.array(NotificationsGroup), []),
  })
  .views(self => ({
    get transport5007() {
      return getParent(self).transport5007;
    },
    get getNotificationsGroups() {
      return self.groups;
    },
    get accountCode() {
      return getRoot(self).uiStore.sessionStore.accountCode;
    },
  }))
  .actions(self => {
    const setGroups = groups => {
      if(!groups || !groups.length){
        return
      }
      self.groups = groups;
    };

    const fetchUsersNotifications = ()=>{
      // try {
      //   const { data } = yield self.transport5007.get(
      //     `system/v1/notifications?accountCode=${self.accountCode}`
      //   );
      //   setGroups(data);
      //   return data;
      // } catch (error) {
      //   console.error(error);
        setGroups([
          {
            groupId: 0,
            name: 'Balance',
            sort: 0,
            notifications: [
              {
                id: 0,
                name: 'Balance running low',
                topBar: true,
                email: true,
                phone: true,
                sort: 0
              },
              {
                id: 1,
                name: 'Balance not sufficient',
                topBar: true,
                email: true,
                phone: true,
                sort: 0
              },
            ]
          },
          {
            groupId: 1,
            name: 'Discover & List',
            sort: 0,
            notifications: [
              {
                id: 2,
                name: 'Scan complete',
                topBar: true,
                email: true,
                phone: true,
                sort: 0
              },
              {
                id: 3,
                name: 'Upload Failed',
                topBar: true,
                email: true,
                phone: true,
                sort: 0
              },
            ]
          },
        ])
        return null;
      // }
    };

    const getDefaults = ()=>{
      // try {
      //   const { data } = yield self.transport5007.get('system/v1/notifications');
      //   return data;
      // } catch (error) {
      //   console.error(error);
        return [
          {
            groupId: 0,
            name: 'Balance',
            sort: 0,
            notifications: [
              {
                id: 0,
                name: 'Balance running low',
                topBar: true,
                email: true,
                phone: true,
                sort: 0
              },
              {
                id: 1,
                name: 'Balance not sufficient',
                topBar: true,
                email: true,
                phone: true,
                sort: 0
              },
            ]
          },
          {
            groupId: 1,
            name: 'Discover & List',
            sort: 0,
            notifications: [
              {
                id: 2,
                name: 'Scan complete',
                topBar: true,
                email: true,
                phone: true,
                sort: 0
              },
              {
                id: 3,
                name: 'Upload Failed',
                topBar: true,
                email: true,
                phone: true,
                sort: 0
              },
            ]
          },
        ];
      // }
    };

    return {
      setGroups,
      getDefaults,
      fetchUsersNotifications,
    };
  });

export default Notifications;
